module.exports = __webpack_public_path__ + "media/src/assets/images/about-pic1-bf050ba4d754bb99a135b5710a16532c.png";